import {
  Box,
  ButtonBase,
  Collapse,
  Grid,
  ListItem,
  Theme,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { IconChevronRight } from "@tabler/icons-react";
import { first, last, map } from "lodash";
import { NotaBMF, NotaBovespa } from "../../../../models/nota";
import { NotaCard } from "./notaCard";

type Props = {
  notas: (NotaBovespa | NotaBMF)[];
};

/** Número/data em accent-ink — accent sólido não passa em contraste no dark. */
const sxDestaque = (theme: Theme) => ({
  color: theme.palette.accentInk,
  fontWeight: 500,
});
export default function NotasManuais({ notas }: Props) {
  const [expandido, setExpandido] = useState(false);

  return (
    <ListItem disableGutters sx={{ px: 2, py: 1 }}>
      <Box display="flex" flexDirection="column" width="100%">
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="flex-start"
          alignItems="center"
        >
          <ButtonBase
            disableRipple
            onClick={() => setExpandido((prev) => !prev)}
            sx={{ borderRadius: "50%" }}
          >
            {/* Box, não o `Icon` do MUI: o Icon usa width/height 1em com
                overflow hidden, e com `fontSize="inherit"` a altura seguia o em
                herdado — cortava o SVG de 16px e o chevron desaparecia. */}
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              sx={(theme) => ({
                width: 20,
                height: 20,
                flexShrink: 0,
                transition: theme.transitions.create("transform", {
                  duration: 120,
                  easing: "ease-out",
                }),
                transform: expandido ? "rotate(90deg)" : "none",
                color: theme.palette.accentInk,
              })}
            >
              <IconChevronRight size={16} strokeWidth={3} />
            </Box>
          </ButtonBase>
          <Box display="flex" flexGrow={1} paddingX={1}>
            <Typography variant="body1" component="div" color="text.secondary">
              <Typography
                variant="labelMono"
                component="span"
                color="text.secondary"
              >
                Notas manuais:
              </Typography>{" "}
              <Typography variant="dataMono" component="span" sx={sxDestaque}>
                {notas.length}
              </Typography>{" "}
              {notas.length > 1 ? "notas" : "nota"} entre{" "}
              <Typography variant="dataMono" component="span" sx={sxDestaque}>
                {first(notas)?.dataPregao.format("DD/MM/YY")}
              </Typography>{" "}
              e{" "}
              <Typography variant="dataMono" component="span" sx={sxDestaque}>
                {last(notas)?.dataPregao.format("DD/MM/YY")}
              </Typography>
              .
            </Typography>
          </Box>
        </Box>
        <Collapse in={expandido}>
          <Grid container spacing={1} sx={{ py: 1, pl: 3 }}>
            {map(notas, (nota) => (
              <Grid item>
                <NotaCard nota={nota} />
              </Grid>
            ))}
          </Grid>
        </Collapse>
      </Box>
    </ListItem>
  );
}
